<template>

  <div class="">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:300vh"
      variant="dark"
      id="loader"
    >
    <b-row>
      <b-col cols="12 headerF"><HeaderFixed/></b-col>
      <b-col cols="12 headerM"><HeaderMobile/></b-col>
    </b-row>
      <b-container id="" fluid style="padding-top: 100px;text-align:left">

        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>One-time Settlement Scheme</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>
        <div class="title">One-Time Settlement Scheme</div>

        <div id="mainDiv" style="display:block">
          <b-tabs content-class="mt-3"  v-model="tabIndex">



          <b-tab title="Check Status" active>
            <b-row>
                  <b-col col cols="12" sm="12" md="12" lg="2" style="padding-top: 7px;">
                        <span style="font-weight:600" >Application Number <span class="text-danger">*</span></span>
                  </b-col>
                  <b-col col cols="8" sm="8" md="8" lg="4">
                      <b-form-input type="text"  id="applNo" v-model="applNumber"   placeholder="Enter your Application Number" trim required />
                  </b-col>
                  <b-col col cols="4" sm="3" md="3" lg="1">
                        <b-button @click="showStatus()" block pill variant="primary" size="md" class="go" id="applClick" style="width:100%">
                          <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                        </b-button>

                  </b-col>
             </b-row>
             <div id="applNotFoundDiv" style="display:none">
              <b-row>
                <b-col cols=12 >
                  <br>
                  <h3 style="color:red">Invalid Application Number</h3>
                </b-col>
              </b-row>
            </div>

                 <div id="statusDetails" class="hideDetails">
                  <b-row>
                    <b-col col cols="12" sm="12" md="4" lg="4">
                        <span class=""> <strong> Application No: <span  id="applNumber"></span></strong> Status : </span>
                    </b-col>
                    <b-col col cols="12" sm="12" md="2" lg="2">
                        <span id="statusDiv"></span>
                    </b-col>
                    <b-col col cols="12" sm="12" md="5" lg="5">
                      <span id="statusFile" class="hideDetails"></span>
                    </b-col>
                  </b-row>
                      <br>
                      <b-row id="showStatusDiv" style="display:none">
                           <b-col col cols="12" sm="12" md="4" lg="4" offset-md="7" offset-lg="7">
                             <span id="acceptStatus"></span>
                           </b-col>

                         </b-row>
                  <b-row id="buttonDiv" class="hideDetails" >
                    <b-col col cols="12" sm="12" md="2" lg="2" offset-md="4" offset-lg="4">
                      <b-button block squared variant="primary" @click="showAcceptDiv()" style="margin-top:5px"> Accept</b-button>
                    </b-col>
                    <b-col col cols="12" sm="12" md="2" lg="2">
                      <b-button block squared variant="danger" @click="showRejectModal()" style="margin-top:5px"> Reject</b-button>
                    </b-col>
                  </b-row>

                </div>
           </b-tab>
        </b-tabs>
      </div>

      <div id="acceptDiv" style="display:none">
        <hr>
        <h3 class="center"> Undertaking</h3>


          <div style="text-align:justify">
        I Shri/Smti. <span class="declaration">{{ consName}}</span>, S/D of <input type="text" id="fatherName"  placeholder=""
          style="border: 0;border-bottom: 1px solid black;" class="declaration">
         hereby undertake that I have filed
        application No. <span class="declaration">{{ applNo }}</span> dated <span class="declaration">{{ applDate }}</span>
        under the scheme notified vide
        Office Order No. APDCL/CGM (Comm & EE)/OTS 2022/6 dated 04/04/2022 and subsequent amendments.
        <br>
        I hereby undertake that the resolution to the application proposed by the Empowered Committee
        vide No. <span class="declaration">{{ resolutionNo }}</span> is fully acceptable to me.
        <br>
        I also undertake that in the event of non-compliance to any of the terms of this arrangement
        under this scheme at any point of time, all consideration under this scheme will be forfeited and
        I will have no claim over any benefit availed.
        <br>
        I also undertake that the matter has attained finality with my acceptance to the resolution and
        I concede my rights to pursue the same before any other forum.
        I also undertake to immediately withdraw all matter(s) being presently pursued.
        <br>
        I also undertake that the consideration is a special one-time dispensation against a specific
        scheme and the same won’t be referred as a precedent for any other case(s).
        <br>
        I also undertake that this undertaking can be used by APDCL as a legal document in any
         legal proceeding on this matter, if needed.
</div>
       <br><br>
       Date: <input type="text" id="acceptDate"  readonly class="declaration"  style="border: 0;border-bottom: 1px solid black;" />
       <br><br>
       Place: <input type="text" id="acceptPlace"   style="border: 0;border-bottom: 1px solid black;" class="declaration">
       <span style="padding-left:50vw"><span class="declaration">( {{ consName}} )</span></span>
<br><br>
       <b-row>

         <b-col col cols="12" sm="12" md="2" lg="2" offset-md="4" offset-lg="4">
           <b-button block squared variant="primary" @click="sendOtp('accept')" style="margin-top:5px"> Submit</b-button>
         </b-col>
         <b-col col cols="12" sm="12" md="2" lg="2">
           <b-button block squared variant="danger" @click="reloadPage()" style="margin-top:5px"> Cancel</b-button>
         </b-col>
       </b-row>
      </div>

  </b-container>
  <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
    <span class="data" id="modalMsg"> DEMO </span>
    <br><br>
      <b-button  style="width:8rem" variant="outline-primary" @click="closeModal('model')">OK</b-button>
  </b-modal>
  </b-overlay>

  <b-modal   no-close-on-esc  no-close-on-backdrop   hide-header id="successModal" centered  scrollable title="Complaint Update" hide-footer>
      <br><br><svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="-180 0 500 130">
        <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
        <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
      </svg>
      <p class="success"> Successfully Saved !<br><br>
       <b-button class="btn btn-outline" variant="success" id="" @click="generatePdf()" >Download Acknowledgement</b-button>
      &nbsp &nbsp  <b-button class="btn btn-outline" variant="danger" id="" @click="closeModalSuccess('successModal');" >Close</b-button>
      </p>
    </b-modal>

    <b-modal   no-close-on-esc  no-close-on-backdrop   hide-header id="successModal1" centered  scrollable title="Complaint Update" hide-footer>
        <br><br><svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="-180 0 500 130">
          <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
          <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
        </svg>
        <p class="success"> Successfully Saved !<br><br>
         <b-button class="btn btn-outline" variant="success" id="" @click="generateUndertakingPdf()" >Download Undertaking</b-button>
        &nbsp &nbsp  <b-button class="btn btn-outline" variant="danger" id="" @click="closeModalSuccess('successModal');" >Close</b-button>
        </p>
      </b-modal>

    <b-modal  no-close-on-esc  no-close-on-backdrop   hide-header id="failureModal" centered  scrollable title="Complaint Update" hide-footer>
    <br><br>  <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="-180 0 500 130">
        <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
        <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
        <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
      </svg>
      <p class="error">Form Save Failed ! <br><br>
        <b-button class="btn btn-outline" variant="danger" id="" @click="closeModal('failureModal');" >OK</b-button>
         </p>
    </b-modal>

    <b-modal  no-close-on-esc  no-close-on-backdrop  id="rejectModal" centered  scrollable title="Reject Resolution" hide-footer>
    <br><br>
      <p class="error">Are you Sure ? <br><br>
        <b-button class="btn btn-outline" variant="danger" id="" @click="sendOtp('reject');" >Yes</b-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <b-button class="btn btn-outline" variant="primary" id="" @click="closeModal('rejectModal');" >No</b-button>
         </p>
    </b-modal>

    <b-modal id="otpModal" centered no-close-on-esc  no-close-on-backdrop title="OTP Verification" hide-footer>
      <b-overlay
      :show="show1"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style=""
      variant="dark"
      id="loader"
    >
      Enter the OTP received in your mobile number <b> {{ consMobile }} </b>
      <b-form-input type="number" id="otp" ></b-form-input><br>
      <b-button class="btn" variant="primary" id="success-btn" @click="verifyOtp()" >Verify</b-button> &nbsp&nbsp
      <b-button class="btn" variant="outline-primary" id="success-btn" @click="resendOtp()" >Resend OTP</b-button>
  </b-overlay>
    </b-modal>
  </div>
</template>

<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
const numWords = require('num-words');

import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

var applNo="";
var currDate='';
var resDate='';
var dateTime;
var dataToSend;
var statusData;
var mobile="";
var submitType="";
export default {
  name: 'AmicableForm',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' :HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {
      checked: false,
      tabIndex: 1,
      consumerNo: '',
      consName:'',
      applNo:'',
      resolutionNo:'',
      settlementDate:'',
      applDate:'',
      show: false,
      litigStatus: '',
      connectionStatus:'',
      settlementOpt:'',
      paymentAmtWord:'',
      declaration:'not_accepted',
      applNumber:'',
      consMobile:'',
      show1:false,
      message : [
        "",
        "No Consumer Found for this Consumer Number",
        "No Outstanding Bill Found for this Consumer Number",
        "This Consumer Number is Blocked",
        "No Bill Found for Payment",
        "",
        "Server Busy! Kindly Try Again After Sometime.",
        "Transaction Already in Progress",
        "Error in Initiating Payment Request with Billdesk"
      ],
    }
  },
  methods: {

      numToWord()
      {

        var num=   document.getElementById("paymentAmt").value;
        const amountInWords = numWords(num);
        this.paymentAmtWord=amountInWords;
      },

      closeModal(modal){
        this.$bvModal.hide(modal)
      },
      closeModalSuccess(modal){
        this.$bvModal.hide(modal)
        window.location.reload();
      },
      showAcceptDiv(){
        document.getElementById('mainDiv').style.display="none";
        document.getElementById('acceptDiv').style.display="block";
      },
      showRejectModal(){
        this.$bvModal.show('rejectModal');
      },
      reloadPage()
      {
        window.location.reload();
      },

      showDetails() {
        var consNo= document.getElementById("consNo").value;

        var parent=this;
        this.show= true;
        axios.post('https://www.apdclrms.com/cbs/RestAPI/myBijulee/ConsDetails?cons_no='+consNo)
        .then((response) => {
          parent.show= false;
          console.log(response.data);
          var data=response.data;
          var status = data.message;

          if(status=="00")
          {
            document.getElementById("consName").value = data.cons_name;
            document.getElementById("mobileNo").value = data.mobile_no;
            document.getElementById("email").value = data.email;
            document.getElementById("applicantName").value = data.cons_name;

            /*
            axios.post('https://apdclrms.com/cbs/RestAPI/OnlineBill/billData?consNo='+consNo+'&billCount=1')
            .then((response) => {
            console.log(response.data);
              response.data.forEach(element => {
                document.getElementById("lastBillNo").value = element.bill_NO;
                document.getElementById("outstandingAmt").value = element.due_AMOUNT+".00";
            })
          })
          */
          }
          else
          {
            parent.show= false;
            // parent.$bvModal.show('model');
            // document.getElementById("modalMsg").innerHTML=" Consumenr Data Not Found, Enter data Manually";
          }


        })
        .catch((e) => {
        console.log("Caught", e);
        this.show= false;
      })

    },

    showStatus()
    {
        var finalCurrDate="";
        var finalResDate="";
        var applNo=document.getElementById("applNo").value;
        if(applNo=="")
          {
          this.$bvToast.toast('Enter Application Number !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
            })
            return;
          }

      var parent=this;
      this.show= true;
      axios.get(parent.$urlCommon + "/api/web/getAmicableStatus?applNo="+applNo)
      .then((response) => {
        console.log(response.data);
        document.getElementById("applNumber").innerHTML=applNo;
        parent.show= false;
        console.log(response.data);
        statusData = response.data;
        this.generateUndertakingPdf();
        return;

        var objLen=Object.keys(response.data).length;
        console.log(Object.keys(response.data).length);
        if(objLen==0)
        {
           document.getElementById("applNotFoundDiv").style.display="block";
           document.getElementById("statusDetails").classList.remove("showDetails");
        }
        else
        {
           document.getElementById("applNotFoundDiv").style.display="none";
           document.getElementById("statusDetails").classList.add("showDetails");
        }

        if(response.data.settlement_status == "Completed"){
          parent.consName=response.data.cons_name;
          mobile=response.data.mobile;

          let newStr = mobile.substring(0,2) + "*****" + mobile.substring(7)
          parent.consMobile = newStr;
          parent.applNo=response.data.application_no;
          parent.resolutionNo=response.data.settlement_file_no;
          var ad = response.data.date.split("-");
          parent.applDate = ad[2]+"/"+ad[1]+"/"+ad[0];
          var cd = response.data.currDate.split("-");
          currDate = cd[2]+"/"+cd[1]+"/"+cd[0];
          var rd = response.data.settlement_date.split("/");
          resDate = rd[2]+"-"+rd[1]+"-"+rd[0];
          finalCurrDate = new Date(response.data.currDate);
          var g2 = new Date(resDate);
          finalResDate = new Date();
          finalResDate.setDate(g2.getDate() + 7);

        }
      })


    },

    generateUndertakingPdf() {

            var docDefinition = {
            pageSize: 'A4',
            pageOrientation: 'portrait',
            content: [
          //     { image: '../assets/apdcl_logo.png',  width: 150,  height: 150,},

             { text: 'ASSAM POWER DISTRIBUTION COMPANY LIMITED', style: 'header' },
              { text: 'Special One-time Settlement Scheme', style: 'subheader' },
              { text: 'UNDERTAKING', style: 'header' },
              { text: '- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -' },

                { text:
                [
                  'I Shri/Smti. ',{text: statusData.cons_name, style: 'boldText'},
                  ' S/D of ',{text: statusData.accept_father_name, style: 'boldText'},
                  ' hereby undertake that I have filed application No. ',{text: statusData.application_no, style: 'boldText'},
                  ' dated ',{text: statusData.date, style: 'boldText'},  ' under the scheme notified vide Office Order No. APDCL/CGM (Comm & EE)/OTS 2022/6 dated 04.04.2022 and subsequent amendments.',
                  '\n\nI hereby undertake that the resolution to the application proposed by the Empowered Committee vide No. ',{text: statusData.settlement_file_no, style: 'boldText'},' is fully acceptable to me.',
                  '\n\nI also undertake that in the event of non-compliance to any of the terms of this arrangement under this scheme at any point of time, all consideration under this scheme will be forfeited and I will have no claim over any benefit availed.',
                  '\n\nI also undertake that the matter has attained finality with my acceptance to the resolution and I concede my rights to pursue the same before any other forum. I also undertake to immediately withdraw all matter(s) being presently pursued.',
                  '\n\nI also undertake that the consideration is a special one-time dispensation against a specific scheme and the same won’t be referred as a precedent for any other case(s).',
                  '\n\nI also undertake that this undertaking can be used by APDCL as a legal document in any legal proceeding on this matter, if needed.\n',
                ],
                 style: 'normalText', alignment: 'justify'
               },

               { text: ['Date: ', {text: statusData.accept_date, style: 'boldText'},], style: 'normalText' },

               {
                 columns: [

                     { text: ['Place: ', {text: statusData.accept_place, style: 'boldText'},], style: 'normalText',  width: 200, },
                     { text: '',   width: 200, },
                    { text: [ {text: "( "+statusData.cons_name+" )", style: 'boldText'},], style: 'normalText',  width: 200, },
                 ]
               },

              { text: '\n\n N.B.- This is a computer-generated statement and no signature is required.' , style: 'footerText'},
                 ],
                 styles: {
                      header: {
                      fontSize: 15,
                      bold: true,
                      alignment: 'center',
                      margin: [0, 0, 0, 5]
                  },
                subheader: {
                    fontSize: 15,
                    alignment: 'center',
                    bold: true,
                    margin: [0, 10, 0, 5]
                },
                applNo: {
                    fontSize: 13,
                    alignment: 'center',
                    color: '#0277bd',
                    margin: [0, 10, 0, 5]
                },
                heading: {
                    fontSize: 12,
                    alignment: 'left',
                    bold: true,
                    margin: [0, 10, 0, 5]
                },
                normalText: {
                    fontSize: 10,
                    alignment: 'left',
                    margin: [0, 10, 0, 5]
                },
                boldText: {
                    fontSize: 11,
                    alignment: 'left',
                    bold:true,
                    margin: [0, 10, 0, 5]
                },
                bottomText: {
                    fontSize: 10,
                    fontWeight: 600,
                    alignment: 'left',
                    margin: [0, 10, 0, 5]
                },
                footerText: {
                    fontSize: 8,
                    alignment: 'left',
                    margin: [0, 10, 0, 5]
                },
                tableExample: {
                    margin: [0, 5, 5, 0],
                    alignment: 'left',
                    fontSize: 10,
                }
            },

          };

          pdfMake.createPdf(docDefinition).download("Ack_" +statusData.application_no+"_"+statusData.cons_name+ ".pdf");
      //   setTimeout(function(){ window.location.reload(); }, 2000);

        },
  },
  mounted()
  {

  }
}

</script>

<style scoped="true">
.hideDetails
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
  /* box-shadow: 2px 2px 10px 2px #bdbdbd; */
  padding: 1rem;
  margin-right: 1.5rem;
}
.declaration
{
  color:#263238;
  font-weight:600;
}
.showDetails
{

  visibility: visible;
 opacity: 1;
}
.sbtBtn
{
  pointer-events: none;
  background-color: grey;
}

.paddingRow{
  padding:0.7rem;
}
.paddingCol{
  padding: none;
}
.label{
font-weight: 600;
}
.data{
  font-weight: 600;
  color: #ff5722         ;
  font-size: 1.5rem;
}
.top{
  text-align: center;
  color:darkblue;
}
.hideDiv
{
   visibility: visible;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;

}
.showDiv
{

  visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}

.headerF{
  display: block;
}
.headerM{
  display: none;
}

.paddingLeft30px{
  padding-left: 30px;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }
  }
@media only screen and (max-width: 414px) {
  .paddingCol{
    padding: 0.7rem;
  }
  .paddingRow{
    padding: none !important;
  }
  .paddingLeft30px{
    padding-left: 0px;
  }
}
.path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 0;
}
.path.circle {
  -webkit-animation: dash 0.9s ease-in-out;
  animation: dash 0.9s ease-in-out;
}
.path.line {
  stroke-dashoffset: 1000;
  -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
  animation: dash 0.9s 0.35s ease-in-out forwards;
}
.path.check {
  stroke-dashoffset: -100;
  -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
  animation: dash-check 0.9s 0.35s ease-in-out forwards;
}

p {
  text-align: center;
  margin: 20px 0 60px;
  font-size: 1.25em;
}
p.success {
  color: #73AF55;
}
p.error {
  color: #D06079;
}
@-webkit-keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@-webkit-keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
@keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}

</style>
